/**
 * Notification State
 * TODO: supported state from powershell is limited. InProgress, Error and Success.
 */
export enum NotificationState {
    /**
     * Can be used internally to differentiate between the first notification of an action and subsequent progress updates
     * This type of notification appears the same as InProgress notifications
     */
    Started = 1,

    /**
     * The notification is has been submitted, started, or is in progress.
     * Use this for status updates for an action currently in progress
     */
    InProgress = 2,

    /**
     * The notification is for a critical message
     * A critical message is something causing the system to be down
     * like a tool is no longer working or a managed node is not manageable
     */
    Critical = 3,

    /**
     * The notification is for an error
     */
    Error = 4,

    /**
     * The notification should display a warning message
     */
    Warning = 5,

    /**
     * The notification action has completed successfully
     */
    Success = 6,

    /**
     * Can be used to tell the user something unrelated to an in progress action
     */
    Informational = 7
}
